import { COMPONENT_NAME as EDIT_GRID_COMPONENT_NAME, IMREditGridComponent } from './edit-grid/edit-grid.component'
import { COMPONENT_NAME as EDIT_GRID_POPUP_COMPONENT_NAME, IMREditGridPopupComponent } from './popup/edit-grid.popup.component'

export const EDIT_GRID_MODULE_NAME = 'simax.common.edit-grid'

const module = angular.module(EDIT_GRID_MODULE_NAME, [])

module.component(EDIT_GRID_COMPONENT_NAME, new IMREditGridComponent())
module.component(EDIT_GRID_POPUP_COMPONENT_NAME, new IMREditGridPopupComponent())
